import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 140px;
  border: 1px solid var(--color-white);
  border-radius: var(--border-radius8);
  background: var(--color-greyEC);
  outline: none;
  overflow: hidden;
  &:disabled {
    border: 1px solid var(--color-white);
    cursor: not-allowed;
  }
  &:focus {
    box-shadow: var(--shadow-focus);
  }
  @media (hover) {
    &:hover {
      border: 1px solid var(--color-grey97);
    }
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
